import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Collapse } from '@material-ui/core';
import StateLabel from '../StateLabel';
import Currency from '../../Currency';
import useStyles from './makeStyles';

const InvoiceCardMobile = ({ invoice, invoiceId, children }) => {
  const [isExpanded, setIsExpanded] = useState({});

  const toggleAccordion = (id) => {
    setIsExpanded({
      ...isExpanded,
      [invoiceId]: !isExpanded[id],
    });
  };
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.invoiceCard}>
          <div className={classes.invoiceCardRow}>
            <span className={classes.label}>{t('claim.cols.invoiceInputDate')}</span>
            <span>{invoice.invoiceInputDate || '-'}</span>
          </div>
          <div className={classes.invoiceCardRow}>
            <span className={classes.label}>{t('claim.cols.claimState')}</span>
            <span>
              <StateLabel invoice={invoice} />
            </span>
          </div>
          <div className={classes.invoiceCardRow}>
            <span className={classes.label}>{t('claim.cols.type')}</span>
            <span>{t(`claim.type.${invoice.type}`)}</span>
          </div>

          <div className={classes.invoiceCardRow}>
            <span className={classes.label}>{t('claim.cols.invoiceAmount')}</span>
            <Currency
              value={invoice.invoiceAmount}
              currency={invoice.invoiceCurrency}
              withCurrencyLabel
            />
          </div>
          <div className={classes.invoiceCardRow}>
            <span className={classes.label}>{t('claim.cols.settledAmount')}</span>
            <Currency
              value={invoice.settledAmount}
              currency={invoice.invoiceCurrency}
              withCurrencyLabel
            />
          </div>
          <Collapse in={isExpanded[invoiceId]} sx={{ textAlign: 'left' }}>
            {children}
          </Collapse>
        </div>
        <div
          role="presentation"
          className={classes.seeMore}
          onClick={() => {
            toggleAccordion(invoiceId);
          }}
        >
          <ExpandMoreIcon
            className={`${classes.arrowIcon} ${isExpanded[invoiceId] ? classes.open : ''}`}
          />
        </div>
      </div>
    </>
  );
};

InvoiceCardMobile.propTypes = {
  invoice: PropTypes.shape({
    invoiceInputDate: PropTypes.string,
    type: PropTypes.string,
    invoiceAmount: PropTypes.number,
    settledAmount: PropTypes.number,
    invoiceCurrency: PropTypes.string,
  }).isRequired,
  invoiceId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default InvoiceCardMobile;
